import _ from 'lodash'
import { EmptyObject } from 'type-fest'

import { SidebarItem } from './types'

export const isSidebarItemEmpty = (item: SidebarItem): item is EmptyObject =>
  _.isEmpty(item as EmptyObject)
